// Échappe le HTML puis convertit uniquement **gras** et *italique* — aucune autre
// balise n'est jamais interprétée (le message vient de l'admin, mais on reste strict :
// c'est injecté via dangerouslySetInnerHTML côté composants).
function escapeHtml(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function formatBannerMessage(raw) {
  let safe = escapeHtml(raw);
  safe = safe.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  safe = safe.replace(/\*(.+?)\*/g, '<em>$1</em>');
  return safe;
}

export function formatDateFr(isoDate) {
  try {
    return new Date(isoDate).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
  } catch (_) {
    return isoDate;
  }
}
